import React from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { IconButton } from "@mui/material";
import {
  // AddCircleOutlineRounded,
  // FullscreenExitRounded,
  // RemoveCircleOutlineRounded,
  // ZoomInMapRounded,
  ZoomInRounded,
  ZoomOutRounded,
} from "@mui/icons-material";

const maxMapSize = 768;
class EurekaMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentScale: 1,
      initialScale: 1,
      initialPositionX: 0,
      initialPositionY: 0,
      navigate: "normal",
      aspectRatio: 1,
      mapScale: 1,
    };
    this.wrapperRef = React.createRef();
    this.setTransform = null;

    this.checkScale = this.checkScale.bind(this);
  }

  locationPinComponent = (pin, showPin) => {
    let color = "red";
    let size = 1;
    let zIndex = 9;
    if (pin.tier === "2") {
      size = 0.6;
      zIndex = 6;
    }
    if (pin.tier === "3") {
      size = 0.4;
      zIndex = 3;
    }
    return (
      <div
        style={{ position: "relative", pointerEvents: "none", zIndex: zIndex }}>
        <svg
          onClick={() => this.props.handlePushUp(pin)}
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="40"
          viewBox="0 0 32 40"
          fill="none"
          style={{
            transform: `scale(${size})`,
            transformOrigin: "center bottom",
            pointerEvents: showPin ? "auto" : "none",
            display: "none"
          }}>
          <path
            d="M16.0044 20.5C17.2356 20.5 18.3137 20.0499 19.1836 19.1761L12.8164 12.8239C11.9475 13.6965 11.5 14.7748 11.5 16.0044C11.5 17.2356 11.9501 18.3137 12.8239 19.1836C13.6965 20.0525 14.7748 20.5 16.0044 20.5ZM19.1836 19.1761C20.0525 18.3035 20.5 17.2252 20.5 15.9956C20.5 14.7644 20.0498 13.6863 19.1761 12.8164C18.3035 11.9475 17.2252 11.5 15.9956 11.5C14.7644 11.5 13.6863 11.9501 12.8164 12.8239L19.1836 19.1761ZM16 38.6828C10.9998 34.363 7.27854 30.3731 4.80324 26.7146C2.22019 22.8969 1 19.4661 1 16.4C1 11.6354 2.52173 7.93463 5.50296 5.1851C8.54181 2.38243 12.0271 1 16 1C19.9729 1 23.4582 2.38243 26.497 5.1851C29.4783 7.93463 31 11.6354 31 16.4C31 19.4661 29.7798 22.8969 27.1968 26.7146C24.7215 30.3731 21.0002 34.363 16 38.6828Z"
            fill={color}
            stroke="white"
            strokeWidth="2"
          />
        </svg>
        {(pin.label !== "" || pin.label === undefined) && (
          <div
            onClick={() => this.props.handlePushUp(pin)}
            style={{
              background: "white",
              height: 24,
              color: "#1B4721",
              padding: "4px 8px",
              border: "2px solid #1B4721",
              borderRadius: 8,
              position: "absolute",
              bottom: 0,
              whiteSpace: "nowrap",
              display: "flex",
              alignItems: "center",
              transform: `translate(-30%, 100%) scale(${size})`,
              transformOrigin: "center top",
              pointerEvents: showPin ? "auto" : "none",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.25)",
            }}>
            {pin.label}
          </div>
        )}
      </div>
    );
  };

  componentDidMount() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize.bind(this));
    // setTimeout(() => {
    //   this.wrapperRef.current.resetTransform();
    // }, 1000);

    setInterval(() => {
      this.checkScale();
    }, 1000);
  }

  checkScale() {
    if (this.wrapperRef.current) {
      let wrapper = this.wrapperRef.current.instance.wrapperComponent;
      let wrapperWidth = wrapper.clientWidth;
      let wrapperHeight = wrapper.clientHeight;
      let mapScale = 1;
      if (wrapperHeight < wrapperWidth) {
        mapScale = wrapperHeight / wrapperWidth;
      }
      this.setState({ mapScale: mapScale });
    }
  }

  getRescaledPosition = (position, type) => {
    // type = "x" or "y"
    // sample original x axis value = min(${pin.pos_x / 10}vw, ${
    //   (maxMapSize * pin.pos_x) / 1000
    // }px)
    // sample original y axis value = min(${pin.pos_y / 10}vw, ${
    //   (maxMapSize * pin.pos_y) / 1000
    // }px)
    // y axis value belongs a aspect ratio of 1
    // get the y axis value for the current aspect ratio, where if aspect ratio is below 1, y will be lower if y is above center point and higher if y is below center point

    // get the y axis value for the current aspect ratio, where if aspect ratio is above 1, y will be lower if y is above center point and higher if y is below center point

    // if aspect ratio is 1, y will be the same as the original y axis value

    // if aspect ratio is below 1, y will be lower if y is above center point and higher if y is below center point
    // if aspect ratio is above 1, y will be lower if y is above center point and higher if y is below center point
    // if aspect ratio is 1, y will be the same as the original y axis value
    if (this.state.aspectRatio < 1) {
      position = position * this.state.aspectRatio;
    } else if (this.state.aspectRatio > 1) {
      position = position / this.state.aspectRatio;
    }
  };

  handleResize() {
    let aspectRatio = 1;
    let realWidth = window.innerWidth;
    let realHeight = window.innerHeight - 320;
    if (realWidth > realHeight) {
      if (realWidth / realHeight < 16 / 9) {
        aspectRatio = 1.25;
      } else if (realWidth / realHeight < 21 / 9) {
        aspectRatio = 1.5;
      } else {
        aspectRatio = 1.75;
      }
    }
    if (realWidth < realHeight) {
      if (realWidth / realHeight < 9 / 21) {
        aspectRatio = 0.45;
      } else if (realWidth / realHeight < 9 / 16) {
        aspectRatio = 0.65;
      } else if (realWidth / realHeight < 9 / 12) {
        aspectRatio = 0.75;
      } else {
        aspectRatio = 1;
      }
    }
    this.setState({ aspectRatio });
  }

  navigateToPin = pin => {
    let scale = 1;
    if (pin.tier === "2") {
      scale = 1.75;
    }
    if (pin.tier === "3") {
      scale = 2.5;
    }
    const baseMapSize = Math.min(maxMapSize, window.innerWidth) - 32;
    const mapSize = baseMapSize * scale;
    if (!this.wrapperRef.current) {
      return;
    }
    let leftPercentage = pin.pos_x / 10;
    let topPercentage = pin.pos_y / 10;

    // get distance between center of map and pin
    let distanceX = Math.min(
      baseMapSize,
      Math.max(0, (leftPercentage * mapSize) / 100 - baseMapSize / 2)
    );
    let distanceY = Math.min(
      baseMapSize,
      Math.max(0, (topPercentage * mapSize) / 100 - baseMapSize / 2)
    );

    this.setState({
      navigate: "done",
      currentScale: scale,
      initialScale: scale,
      initialPositionX: -distanceX,
      initialPositionY: -distanceY,
    });
  };

  navigateToCenter() {}

  render() {
    return (
      this.props.mapURL !== "" && (
        <>
          <div
            id="eureka-map"
            style={{
              display: "flex",
              justifyContent: "center",
              height: this.props.currentHeight - 128 - 96,
            }}>
            <div>
              <TransformWrapper
                ref={this.wrapperRef}
                key={this.state.navigate}
                initialScale={this.state.initialScale}
                initialPositionX={this.state.initialPositionX}
                initialPositionY={this.state.initialPositionY}
                onTransformed={e => {
                  this.setState({ currentScale: e.state.scale });
                }}>
                {({
                  zoomIn,
                  zoomOut,
                  resetTransform,
                  setTransform,
                  ...rest
                }) => {
                  this.setTransform = setTransform;
                  return (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        display: "grid",
                        gridTemplateRows: "48px 1fr",
                      }}>
                      <div className="tools">
                        <IconButton
                          sx={{
                            fill: "white",
                          }}
                          onClick={() => zoomIn()}>
                          <ZoomInRounded
                            sx={{
                              fill: "white",
                            }}
                          />
                        </IconButton>
                        <IconButton
                          sx={{
                            fill: "white",
                          }}
                          onClick={() => zoomOut()}>
                          <ZoomOutRounded
                            sx={{
                              fill: "white",
                            }}
                          />
                        </IconButton>
                      </div>
                      <TransformComponent
                        contentStyle={{
                          borderRadius: 12,
                          height: "100%",
                        }}
                        wrapperStyle={{
                          borderRadius: 16,
                          background: "#093832",
                          transform: "scale(0.975)",
                          transformOrigin: "top center",
                          height: "-webkit-fill-available",
                        }}>
                        <div
                          style={{
                            width: `min(${maxMapSize}px, 100vw)`,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            transform: `scale(${this.state.mapScale * 0.95})`,
                            transition: "transform 0.5s ease",
                            transformOrigin: "top center",
                            // boxSizing: "border-box",
                          }}>
                          <div
                            style={{
                              pointerEvents: "all",
                              width: `min(${maxMapSize}px, 100vw)`,
                              aspectRatio: 1,
                              background: "#093832",
                              position: "relative",
                              justifyItems: "center",
                              alignItems: "center",
                              borderRadius: "10px",
                            }}>
                            <img
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                              }}
                              src={this.props.mapURL}
                              alt=" FITC Map"
                            />
                            <div id="map-pins">
                              {this.props.mapPins.map((pin, i) => {
                                let showPin = false;
                                let halfColor = false;
                                if (pin.enable === 1) {
                                  if (
                                    this.state.currentScale === 1 &&
                                    (pin.tier === "1" || pin.tier === "2")
                                  ) {
                                    showPin = true;
                                    if (pin.tier === "2") {
                                      halfColor = true;
                                    }
                                  }
                                  if (
                                    this.state.currentScale > 1 &&
                                    this.state.currentScale <= 2 &&
                                    (pin.tier === "2" || pin.tier === "3")
                                  ) {
                                    showPin = true;
                                    if (pin.tier === "3") {
                                      halfColor = true;
                                    }
                                  }
                                  if (
                                    this.state.currentScale > 2 &&
                                    this.state.currentScale <= 10 &&
                                    pin.tier === "3"
                                  ) {
                                    showPin = true;
                                    if (pin.tier === "2") {
                                      halfColor = true;
                                    }
                                  }
                                  return (
                                    <div
                                      key={`pin-${i}`}
                                      id={`map-pin-${pin.id}`}
                                      style={{
                                        transform: "translate(-50%, -100%)",
                                        position: "absolute",
                                        top: `min(${pin.pos_y / 10}vw, ${
                                          (maxMapSize * pin.pos_y) / 1000
                                        }px)`,
                                        left: `min(${pin.pos_x / 10}vw, ${
                                          (maxMapSize * pin.pos_x) / 1000
                                        }px)`,
                                        pointerEvents: showPin ? "all" : "none",
                                        cursor: "pointer",
                                        zIndex: 100,
                                        opacity: showPin
                                          ? halfColor
                                            ? 0.5
                                            : 1
                                          : 0,
                                      }}>
                                      {this.locationPinComponent(pin, showPin)}
                                    </div>
                                  );
                                }
                                return null;
                              })}
                            </div>
                          </div>
                        </div>
                      </TransformComponent>
                    </div>
                  );
                }}
              </TransformWrapper>
            </div>
          </div>
          <div
            style={{
              height: 200,
              // background: "purple",
            }}></div>
        </>
      )
    );
  }
}

export default EurekaMap;
